export default {
  mounted() {
    this.$store.commit('endLoad');
  }
};
